<google-map (mapClick)="onMapClick($event)" *ngIf="center && mapOptions" [center]="center" width="100%"
  [height]="height" [options]=" mapOptions">
  <app-polygonos [ubicaciones]="otrasUbicaciones" [onPolygonClick]="onPolygonClickCallback" [cLinea]="cLinea"
    [cRelleno]="cRelleno" [opacidad]="opacidad"></app-polygonos>

  <app-pivot *ngIf="pivots && pivots.length > 0" [pivots]="pivots" [pivotSeleccionadoId]="pivotSeleccionadoId">
  </app-pivot>

  <ng-container *ngIf="!esPolyline">
    <ng-container *ngFor="let polygon of polygonOptions; let i = index">
      <map-polygon [options]="polygon" (polygonClick)="handlePolygonClick($event, polygon)"></map-polygon>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="esPolyline">
    <ng-container *ngFor="let polyline of polylineOptions; let i = index">
      <map-polyline [options]="polyline" (polylineClick)="handlePolylineClick($event, polyline)"></map-polyline>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="esCircle && circuloDibujado">
    <map-circle [center]="circuloDibujado.centro" [radius]="circuloDibujado.radio" [options]="{
    strokeColor: cLinea,
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: cRelleno,
    fillOpacity: 0.35,
    clickable: true,
    editable: editable
  }"></map-circle>
  </ng-container>

  <ng-container>
    <ng-container *ngFor="let circle of circleOptions; let i = index">
      <map-circle (circleClick)="handleCircleClick($event, circle)" [center]="circle.center ?? {lat: 0, lng: 0}"
        [radius]="circle.radius ?? 0" [options]="circle">
      </map-circle>
    </ng-container>
  </ng-container>

  <map-info-window style="max-width: 100%;" #infoWindow="mapInfoWindow">
    <div class="info-window">
      <div class="info-titulo">
        <p>
          {{ambiente?.nombre}}
        </p>
      </div>
      <div class="info-subtitulo">
        <p>{{ ambiente?.establecimiento?.nombre }}</p>
      </div>
      <div class="item-list-container">

        <div *ngFor="let lanzaHumedad of ambiente?.lanzaHumedad">
          <div class="item-list">
            <div matPrefix style="width: 30px; height: 30px" matTooltip="Lanzas Humedad de Suelo">
              <mat-icon svgIcon="shss" inline></mat-icon>
            </div>
            <div class="nombre-container">
              <p>{{ lanzaHumedad?.nombre }}</p>
              <span class="mini-text"> {{lanzaHumedad?.ultimoReporte?.fecha | date:'dd/MM/yyyy HH:mm:ss'}} </span>
            </div>
            <div class="alertas-container">
              <p>{{calcularPromedioHumedad(lanzaHumedad.ultimoReporte?.reporte) }}% <span
                  class="mini-text">Humedad</span></p>
              <p>{{calcularPromedioTemperatura(lanzaHumedad.ultimoReporte?.reporte) }}c°
                <span class="mini-text">Temperatura</span>
              </p>
            </div>
          </div>
        </div>

        <div *ngFor="let sensorHumedadSuelo of ambiente?.sensorHumedadSuelos">
          <div class="item-list">
            <div matPrefix style="width: 30px; height: 30px" matTooltip="Sensores de Humedad de Suelo">
              <mat-icon svgIcon="shss" inline></mat-icon>
            </div>
            <div class="nombre-container">
              <p>{{ sensorHumedadSuelo?.nombre }}</p>
              <span class="mini-text"> {{sensorHumedadSuelo?.ultimoReporte?.fecha | date:'dd/MM/yyyy HH:mm:ss'}}
              </span>
            </div>
            <div class="alertas-container">
              <p>{{sensorHumedadSuelo.ultimoReporte?.reporte?.humedad}}% <span class="mini-text">Humedad</span></p>
              <p>{{sensorHumedadSuelo.ultimoReporte?.reporte?.temperatura}}c°
                <span class="mini-text">Temperatura</span>
              </p>
            </div>
          </div>
        </div>
        <div *ngFor="let pluviometro of ambiente?.pluviometros">
          <div class="item-list">
            <div matPrefix style="width: 30px; height: 30px" matTooltip="Pluviometros">
              <mat-icon svgIcon="pluviometros" inline></mat-icon>
            </div>
            <div class="nombre-container">
              <p>{{ pluviometro?.nombre }}</p>
              <span class="mini-text"> {{pluviometro?.ultimoReporte?.fecha | date:'dd/MM/yyyy HH:mm:ss'}} </span>
            </div>
            <div class="alertas-container">
              <p>{{ pluviometro.ultimoReporte?.reporte?.valorAcumulado?.toFixed(2) }}mm <span
                  class="mini-text">Acumulado</span></p>
              <p>{{pluviometro.ultimoReporte?.reporte?.valorInstantaneo}}mm <span class="mini-text">Instantaneo</span>
              </p>
            </div>
          </div>
        </div>
        <div *ngFor="let freatimetro of ambiente?.freatimetros">
          <div class="item-list">
            <div matPrefix style="width: 30px; height: 30px" matTooltip="Freatimetros">
              <mat-icon svgIcon="freatimetros" inline></mat-icon>
            </div>
            <div class="nombre-container">
              <p>{{ freatimetro?.nombre }}</p>
              <span class="mini-text"> {{freatimetro?.ultimoReporte?.fecha | date:'dd/MM/yyyy HH:mm:ss'}} </span>
            </div>
            <div class="alertas-container">
              <p>{{freatimetro.ultimoReporte?.reporte?.nivel}}cm <span class="mini-text">Nivel Napa</span></p>
            </div>
          </div>
        </div>
        <div *ngFor="let estacionMeteorologica of ambiente?.estacionMeteorologicas">
          <div class="item-list">
            <div matPrefix style="width: 30px; height: 30px" matTooltip="Est. Meteorológicas">
              <mat-icon svgIcon="meteorologicas" inline></mat-icon>
            </div>
            <div class="nombre-container">
              <p>{{ estacionMeteorologica?.nombre }}</p>
              <span class="mini-text"> {{estacionMeteorologica?.ultimoReporte?.fecha | date:'dd/MM/yyyy HH:mm:ss'}}
              </span>
            </div>
            <div class="alertas-container">
              <p>{{estacionMeteorologica.ultimoReporte?.reporte?.temperatura}}c°
                <span class="mini-text">Temperatura</span>
              </p>
              <p>{{estacionMeteorologica.ultimoReporte?.reporte?.humedad}}%
                <span class="mini-text">Humedad</span>
              </p>
              <p>{{estacionMeteorologica.ultimoReporte?.reporte?.presion}}
                <span class="mini-text">Presión Atm.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </map-info-window>
</google-map>

<div class="btn-pivot" *ngIf="editable">
  <button *ngIf="(esCircle && (circuloDibujado || ambiente?.ubicacion?.circulo))" type="button"
    (click)="activarAgregarPuntoLlegada()" mat-raised-button color="primary">
    Agregar punto de llegada
  </button>
</div>

<div class="btn-crear" *ngIf="editable">
  <!-- Agregar Poligono -->
  <button *ngIf="mostrarCrear()" class="mx-2" type="button" mat-fab [matTooltip]="'Crear'" [color]="'accent'"
    (click)="dibujar()">
    <mat-icon>add</mat-icon>
  </button>

  <!-- Cancelar -->
  <button *ngIf="dibujando" class="mx-2" type="button" mat-fab [matTooltip]="'Cancelar'" [color]="'warn'"
    (click)="cancelarDibujo()">
    <mat-icon>clear</mat-icon>
  </button>

  <!-- Eliminar -->
  <button *ngIf="hayElementosParaEliminar()" class="mx-2" type="button" mat-fab [matTooltip]="'Eliminar'"
    [color]="'warn'" (click)="eliminar()">
    <mat-icon>delete</mat-icon>
  </button>
</div>